import { render, staticRenderFns } from "./FaceFlip.vue?vue&type=template&id=d7fc9354&"
import script from "./FaceFlip.vue?vue&type=script&lang=js&"
export * from "./FaceFlip.vue?vue&type=script&lang=js&"
import style0 from "./FaceFlip.vue?vue&type=style&index=0&id=d7fc9354&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports